var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrmSelectapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 88,
    viewBox: "0 0 182 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_561_4500)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 88,
    fill: "#F6F3FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_561_4500)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 120,
    height: 155,
    rx: 6,
    fill: "white",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 87C45 85.8954 45.8954 85 47 85H137C138.105 85 139 85.8954 139 87V89C139 90.1046 138.105 91 137 91H47C45.8954 91 45 90.1046 45 89V87Z",
    fill: "#997BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8171 47.3633C50.7917 47.3633 45.0898 53.0651 45.0898 60.0906C45.0898 67.116 50.7917 72.8178 57.8171 72.8178C64.8426 72.8178 70.5444 67.116 70.5444 60.0906C70.5444 53.0651 64.8426 47.3633 57.8171 47.3633V47.3633ZM57.8174 51.1816C59.9301 51.1816 61.6356 52.8871 61.6356 54.9998C61.6356 57.1126 59.9301 58.818 57.8174 58.818C55.7047 58.818 53.9992 57.1126 53.9992 54.9998C53.9992 52.8871 55.7047 51.1816 57.8174 51.1816V51.1816ZM57.8168 69.2541C54.635 69.2541 51.8223 67.625 50.1805 65.1559C50.2187 62.6232 55.2714 61.2359 57.8168 61.2359C60.3496 61.2359 65.415 62.6232 65.4532 65.1559C63.8114 67.625 60.9987 69.2541 57.8168 69.2541V69.2541Z",
    fill: "url(#paint0_linear_561_4500)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 61,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#997BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 55C76 53.8954 76.8954 53 78 53H123C124.105 53 125 53.8954 125 55V56C125 57.1046 124.105 58 123 58H78C76.8954 58 76 57.1046 76 56V55Z",
    fill: "#997BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 31C40 28.7909 41.7909 27 44 27H133C135.209 27 137 28.7909 137 31V38C137 40.2091 135.209 42 133 42H44C41.7909 42 40 40.2091 40 38V31Z",
    fill: "url(#paint1_linear_561_4500)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_561_4500",
    x: -1,
    y: -13,
    width: 184,
    height: 219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.533333 0 0 0 0 0.533333 0 0 0 0 0.533333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_4500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_561_4500",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_4500",
    x1: 44.999,
    y1: 46.9995,
    x2: 65.999,
    y2: 75.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#997BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C349F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_561_4500",
    x1: 37.5,
    y1: 27,
    x2: 137,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C349F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_561_4500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmSelectapp);
export default __webpack_public_path__ + "static/media/crm-selectapp.17747595f53a35bba22963f6264aee9a.svg";
export { ForwardRef as ReactComponent };